
const m = window.require("truth-helpers/helpers/eq");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
